const GOOGLE_ANALYTICS_ID = "G-9BSMZ3CZB8";
const GTAG_SCRIPT_ID = "google-analytics-gtag";

function isGoogleAnalyticsEnabled() {
  return process.env.NODE_ENV === "production" && typeof window !== "undefined";
}

function ensureGtag() {
  if (!isGoogleAnalyticsEnabled()) {
    return false;
  }

  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function gtag() {
    window.dataLayer.push(arguments);
  };

  return true;
}

export function initGoogleAnalytics() {
  if (!ensureGtag()) {
    return;
  }

  if (!document.getElementById(GTAG_SCRIPT_ID)) {
    const script = document.createElement("script");
    script.id = GTAG_SCRIPT_ID;
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GOOGLE_ANALYTICS_ID}`;
    document.head.appendChild(script);
  }

  window.gtag("js", new Date());
  window.gtag("config", GOOGLE_ANALYTICS_ID);
}

export function trackGoogleAnalyticsEvent(eventName, params) {
  if (!eventName || !ensureGtag()) {
    return;
  }

  window.gtag("event", eventName, Object.assign({
    app_platform: "webtv",
  }, params || {}));
}

export function trackScreenView(location) {
  if (!location) {
    return;
  }

  var path = location.pathname || "/";
  var search = location.search || "";

  trackGoogleAnalyticsEvent("screen_view", {
    screen_name: path,
    screen_class: path,
    page_path: path + search,
    page_location: window.location.origin + path + search,
  });
}
